import router from '@/router'
import firebase from 'firebase/app';
import 'firebase/auth';
import format from 'date-fns/format'
import axios from 'axios'
import { getByUser, getCompany } from '../core/cacheService'
export default {
    namespaced: true,
    state: {
      error: null,
      loading: false,
      user:null,
      userbeforelogin:null,
      activeIndex:'1',
      useremail:'',
      p:'happily_2018',
      companyData: null,
      errorip:'',
      pagePermission: null,
    },
    mutations: {
      errorMessage (state:any, error:any) {
        state.error = error
      },
      loadingStatus(state:any, loading:boolean) {
        state.loading = loading
      },
      setUserLogin (state:any, user:any) {
        // user.team='-L0Dg4P9voDNUxuEH8UV'
        // user.email='tareef_j@dhas.com'
        // user.user_type='leadership'
       // user.company='---TEST---'
        state.user = user
      },
      setActiveIndex(state:any, value:string){
        state.activeIndex = value
      },
      setUserEmail(state:any, value:string){
        state.useremail = value
      },
      setErrorIP(state:any, value:string){
        state.errorip = value
      },
      setUserBeforeLogin(state:any, user:any){
        state.userbeforelogin = user
      },
      setCompanyData(state:any, user:any){
        state.companyData = user
      },
      setPagePermission(state:any, data:any){
        state.pagePermission = data
      },
  
    },
    actions: {
      setUserLogin ({commit}:any){
        const userData:any = localStorage.getItem('userData')
    
        if(userData){
          try {
            commit('setUserLogin', JSON.parse(decodeURIComponent(atob(userData) || '{}')))
          } catch (error) {
            firebase.auth().signOut()
            localStorage.removeItem('userData')
            commit('setUserLogin', null)
            router.replace('/login')
          }
        }
      },
      async loginpincode({commit, dispatch, state}:any, authData:any){
        commit('loadingStatus', true)
        const emailKey = state.useremail.replace(/\./g, '||')
        const user = (await firebase.database().ref(`/login_send_email_web/${emailKey}`).once('value')).val()
        if(user.code4digit == authData.pincode.trim()){
          firebase.auth().signInWithEmailAndPassword(state.useremail, state.p).then(async (res) => {
            let user:any = null
            if(state.useremail){
              var userReal = await getByUser(state.useremail)//(await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
            }
            if(userReal){
              user = userReal
            }else{
              const userAdviser = (await firebase.database().ref(`/users_adviser/${emailKey}`).once('value')).val()
              if(userAdviser){
                user = userAdviser
              }
            }
            if(!user){
              firebase.auth().signOut()
              dispatch('clearError')
              commit('errorMessage', 'Please recheck your user')
              setTimeout(() => {
                commit('loadingStatus', false)
              }, 500)
            }else{
              const company = await getCompany(user.company)
              const user2 = {
                company_name:company.name,
                company:user.company,
                firstname:user.firstname,
                lastname:user.lastname,
                user_type:user.user_type,
                email:user.email,
                profilepic:(user.profilepic)?user.profilepic:'',
                profilepic_crop:(user.profilepic_crop)?user.profilepic_crop:'',
                profilepic_small:(user.profilepic_small)?user.profilepic_small:'',
                team:(user.team)?user.team:'',
              }
              commit('setUserLogin',user2)

              localStorage.setItem('userVersion',await (await firebase.database().ref(`version/my_version`).once("value")).val())
              localStorage.setItem('userData', btoa(encodeURIComponent(JSON.stringify(user2))))
              
              // Register account for multi-account switcher (for + email users)
              dispatch('accountSwitcher/registerAccount', {
                email: user.email,
                userData: user2,
                isSSO: false
              }, { root: true })
              
              // Clear the "adding account" flag if it was set
              localStorage.removeItem('addingAccount')
              
              /*save logs*/
              dispatch('authen/addLogs', {
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                status: 'login',
                user: user.email
              }, {root:true}).then(function() {
                setTimeout(() => {
                 
                  if (user.user_type == 'admin') {
                    router.replace('/members')  
                  } else if(user.user_type == 'developer'){
                    router.replace('/integrations')  
                  }else if(authData.freetrial){
                    router.replace('/setup-wizard')  
                  } else{
                    router.replace('/')
                  }
                  commit('loadingStatus', false)
                }, 500);
              });
            }
          }).catch(function(error) {
              var errorCode = error.code
              var errorMessage = error.message
              if (errorCode === 'auth/wrong-password') {
                  console.log('Wrong password.')
              } else {
                  console.log(errorMessage)
              }
              dispatch('clearError')
              setTimeout(() => {
                commit('errorMessage', errorMessage)
                commit('loadingStatus', false)
              }, 500);
          })
        }else{
          dispatch('clearError')
          setTimeout(() => {
            commit('errorMessage', 'Please recheck your PIN code')
            commit('loadingStatus', false)
          }, 500);
        }
      },
      async login ({commit, dispatch}:any, authData: {email: string; user?: any; company?: any; freetrial?: boolean}) {
        commit('loadingStatus', true)
        authData.email = authData.email.toLowerCase()
        const emailKey = authData.email.replace(/\./g, '||')
        const user = authData.user;
        const company = authData.company;

        if(user) {
          if(company && company.ips){
            let ip = '';
            const url = 'https://api.ipify.org?format=json'
            await axios.get(url).then(response => {
              ip = response.data.ip
            })
            .catch(function (error) {
                console.log(error);
            });
            if(!company.ips.includes(ip)){
              commit('setErrorIP',ip)
              commit('loadingStatus', false)
              return;
            }
          }
        }
       
        if(user && user.user_type != 'user'){
          commit('setUserEmail',authData.email)
          commit('setUserBeforeLogin',user)
          commit('loadingStatus', false)
          const keyId = firebase.database().ref('/loginweb').push({
              email: user.email, 
              firstname: user.firstname, 
              lastname: user.lastname,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
          }).key;
          localStorage.removeItem('userData')
          if(!authData.freetrial){
            router.replace('/pincode')
          }
         
        }else{
          const userAdviser = (await firebase.database().ref(`/users_adviser/${emailKey}`).once('value')).val()
          if(userAdviser && userAdviser.user_type != 'user'){
            commit('setUserEmail',authData.email)
            commit('setUserBeforeLogin',userAdviser)
            commit('loadingStatus', false)
            const keyId = firebase.database().ref('/loginweb_adviser').push({
                email: userAdviser.email, 
                firstname: userAdviser.firstname, 
                lastname: userAdviser.lastname,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }).key;
            // console.log(keyId)
            localStorage.removeItem('userData')
            if(!authData.freetrial){
              router.replace('/pincode')
            }
          }else{
            setTimeout(() => {
              commit('loadingStatus', false)
              dispatch('clearError')
              commit('errorMessage', 'Please recheck your login credentials.')
            }, 500);
          }
        }
        /*firebase.auth().signInWithEmailAndPassword(authData.email, authData.password).then(async (res) => {
          const emailKey = authData.email.replace(/\./g, '||')
          const user = (await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
          if(!user){
            firebase.auth().signOut()
            dispatch('clearError')
            commit('errorMessage', 'Please recheck your user')
            setTimeout(() => {
              commit('loadingStatus', false)
            }, 500)
          }else{
            const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
            user.company_name = company.name
            commit('setUserLogin',user)
            localStorage.setItem('userData', JSON.stringify(user))
            setTimeout(() => {
              commit('loadingStatus', false)
              router.replace('/')  
            }, 500);
          }
        }).catch(function(error) {
            var errorCode = error.code
            var errorMessage = error.message
            if (errorCode === 'auth/wrong-password') {
                console.log('Wrong password.')
            } else {
                console.log(errorMessage)
            }
            dispatch('clearError')
            setTimeout(() => {
              commit('errorMessage', errorMessage)
              commit('loadingStatus', false)
            }, 500);

        })*/
      },
      logout ({commit, dispatch}:any) {

        if(window.navigator && navigator.serviceWorker) {
          navigator.serviceWorker.getRegistrations()
          .then(function(registrations) {
            for(let registration of registrations) {
              registration.unregister();
            }
          });
        }
      
        /*save logs*/
        const userData:any = localStorage.getItem('userData')
        let user = JSON.parse(decodeURIComponent(atob(userData)))
        dispatch('authen/addLogs', {
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          status: 'logout',
          user: user.email
        }, {root:true}).then(function() {
          firebase.auth().signOut()

          localStorage.removeItem('userVersion')
          localStorage.removeItem('userData')
          localStorage.removeItem('lastActivity')
          commit('setUserLogin', null)
          
          // Notify account switcher of logout (keeps account list for quick re-login)
          dispatch('accountSwitcher/handleLogout', null, { root: true })

          router.replace('/login')
        });
      },
      clearError ({commit}:any) {
        commit('errorMessage', null)
      },
      async getCompanyData ({commit, dispatch}:any, authData:any) {
        const company = await getCompany(authData.company)
        company.key=authData.company
        commit('setCompanyData', company)
      },
      pagePermission({commit}:any) {
        const pagePermission = {
          insights: {
            path: "insights",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          members: {
            path: "members",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          questions: {
            path: "questions",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          skills: {
            path: "skills",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          rewards: {
            path: "rewards",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          power_ups: {
            path: "power_ups",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          recognition: {
            path: "recognition",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          performance: {
            path: "performance",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          sparks: {
            path: "sparks",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          happily_village: {
            path: "happily_village",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          reports: {
            path: "reports",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: true,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          integrations: {
            path: "integrations",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: false,
              lock: false,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          billing: {
            path: "billing",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          settings: {
            path: "settings",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          awards: {
            path: "awards",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: true,
              lock: true,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: true,
              lock: true,
            },
            superadmin: {
              disable: true,
              lock: true,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          status_page: {
            path: "status-page",
            user: {
              disable: false,
              lock: false,
            },
            admin: {
              disable: false,
              lock: false,
            },
            hr: {
              disable: false,
              lock: false,
            },
            leadership: {
              disable: false,
              lock: false,
            },
            superleader: {
              disable: false,
              lock: false,
            },
            superadmin: {
              disable: false,
              lock: false,
            },
            developer: {
              disable: false,
              lock: false,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          setup_wizard: {
            path: "setup_wizard",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: true,
              lock: true,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: true,
              lock: true,
            },
            superadmin: {
              disable: true,
              lock: true,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
          document_developer: {
            path: "document_developer",
            user: {
              disable: true,
              lock: true,
            },
            admin: {
              disable: true,
              lock: true,
            },
            hr: {
              disable: true,
              lock: true,
            },
            leadership: {
              disable: true,
              lock: true,
            },
            superleader: {
              disable: true,
              lock: true,
            },
            superadmin: {
              disable: true,
              lock: true,
            },
            developer: {
              disable: true,
              lock: true,
            },
            ghost: {
              disable: false,
              lock: false,
            },
          },
        }
        commit('setPagePermission', pagePermission);
      },
      async addLogs({ commit, rootState, dispatch }: any, object: any){
        let ip = '';
        const url = 'https://api.ipify.org?format=json'
        await axios.get(url).then(response => {
          ip = response.data.ip
        })
        .catch(function (error) {
            console.log(error);
        });
        object.ip = ip;
        await firebase.firestore().collection('logs').add(object);
        return true;
      }
    },
    getters: {
        user : (state:any) => {
          return state.user
        },
        error : (state:any) => {
            return state.error
        },
        loading: (state:any) => {
          return state.loading
        },
        checkLogin: (state:any) => {
          return (state.user)?true:false
        },
        activeIndex: (state:any) => {
          return state.activeIndex
        },
        useremail: (state:any) => {
          return state.useremail
        },
        companyData: (state:any) => {
          return state.companyData
        },
        errorip: (state:any) => {
          return state.errorip
        },
        pagePermission: (state:any) => {
          return state.pagePermission
        },
    }
  }

function dispatch(arg0: string) {
  throw new Error('Function not implemented.');
}
